export default __webpack_public_path__ + "static/media/show-2.3139e327.svg";